import { render, staticRenderFns } from "./VenueCampaign.vue?vue&type=template&id=1f519f68&"
import script from "./VenueCampaign.vue?vue&type=script&lang=js&"
export * from "./VenueCampaign.vue?vue&type=script&lang=js&"
import style0 from "./VenueCampaign.vue?vue&type=style&index=0&id=1f519f68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports